import React from "react";
import "../../../styles/contactos.css";
import site from "../../../imgs/Icons/site.svg";
import tel from "../../../imgs/Icons/tel.svg";
import email from "../../../imgs/Icons/email.svg";
import morada from "../../../imgs/Icons/morada.svg";
import time from "../../../imgs/Icons/time_black.svg";
import { withNamespaces } from "react-i18next";

const OutrosServicos = ({ t }) => {
  
  const formatPhoneValues = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `+351 ${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }

  return (
    <>
      <div
        className="accordion accordions_margin"
        id="accordionExample_Oservicos"
      >
        {/* 1 - UA_INTERCULTURAL */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="ua_i">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cUa_i"
              aria-expanded="true"
              aria-controls="cUa_i"
            >
              {t('moduleContactosEstruturas:S3.A.A1.T')}
            </button>
          </h2>
          <div
            id="cUa_i"
            className="accordion-collapse collapse"
            aria-labelledby="ua_i"
            data-bs-parent="#accordionExample_Oservicos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S3.A.A1.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S3.A.A1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S3.A.A1.P2')}>
                    {t('moduleContactosEstruturas:S3.A.A1.P2')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEstruturas:S3.A.A1.P3')}
                  >
                    {t('moduleContactosEstruturas:S3.A.A1.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S3.A.A1.P4')}
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEstruturas:S3.A.A1.P5')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 2 - CLIAM_UA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="claim_ua">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cClaim_ua"
              aria-expanded="true"
              aria-controls="cClaim_ua"
            >
              {t('moduleContactosEstruturas:S3.A.A2.T')}
            </button>
          </h2>
          <div
            id="cClaim_ua"
            className="accordion-collapse collapse"
            aria-labelledby="claim_ua"
            data-bs-parent="#accordionExample_Oservicos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S3.A.A2.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S3.A.A2.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S3.A.A2.P2')}>
                    {t('moduleContactosEstruturas:S3.A.A2.P2')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEstruturas:S3.A.A2.P3')}
                  >
                    {t('moduleContactosEstruturas:S3.A.A2.P3')}
                  </a>
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEstruturas:S3.A.A2.P4')}
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S3.A.A2.P5')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 3 - GABINETE PEDAGOGICO */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="gabinete">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cGabinete"
              aria-expanded="true"
              aria-controls="cGabinete"
            >
              {t('moduleContactosEstruturas:S3.A.A3.T')}
            </button>
          </h2>
          <div
            id="cGabinete"
            className="accordion-collapse collapse"
            aria-labelledby="gabinete"
            data-bs-parent="#accordionExample_Oservicos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" href={"tel:+351" +
                    t('moduleContactosEstruturas:S3.A.A3.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S3.A.A3.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S3.A.A3.P2')}>
                    {t('moduleContactosEstruturas:S3.A.A3.P2')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEstruturas:S3.A.A3.P3')}
                  >
                    {t('moduleContactosEstruturas:S3.A.A3.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S3.A.A3.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces()(OutrosServicos);

